import Icon from 'core/components/icons/Icon'
import { useEffect } from 'react'
import useSLT from 'core/hooks/auth/useSLT'
import useNavigation from 'core/hooks/navigation/useNavigation'

const NewExperiencePage = () => {
  const purpleDashboardUrl = import.meta.env.VITE_APP_PURPLE_DASHBOARD_URL
  const {
    state: { userId, authToken }
  } = useNavigation()

  const { getSLT } = useSLT({
    onSuccess: (slt) => {
      window.location.replace(
        purpleDashboardUrl.addUrlParams({
          slt
        })
      )
    },
    onError: () => {
      window.location.replace(purpleDashboardUrl)
    }
  })

  useEffect(() => {
    if (userId && authToken) {
      getSLT({ userId, authToken })
      return
    }
    window.location.replace(purpleDashboardUrl)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="w-full h-[95vh] absolute grid place-items-center mx-auto">
      <div className="flex flex-col items-center gap-5 text-center">
        <Icon
          name="loading"
          size={60}
          color="text-[#440099]"
          className="mb-5"
        />
        <p className="text-xl">You are signed in to your dashboard.</p>
      </div>
    </div>
  )
}

export default NewExperiencePage
